<template>
  <CContainer fluid>
    <!-- Header -->
    <CRow class="mt-3">
      <CCol col="12" sm="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol col="9" sm="9">
                <h5 class="text-muted mt-2">&#128075; Hola! Muy {{ saludoHorario }}, bienvenidos a <strong>&Oacute;ptimo SBM</strong> (Smart Business Management)</h5>
                <p>La TRM del dia de hoy es <span class="h4"><strong>${{ $store.state.user.data.TRM }}</strong></span></p>
              </CCol>
              <CCol col="3" sm="3" class="text-right">
                <img :src="urlHeader" alt="" class="img-fluid">
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <!-- Body -->
    <CCard>
      <CCardBody>
        <CDataTable 
          :items="items"
          :fields="fields"
          :responsive="true">
          <template #documento="{item}">
            <td>
              <h4>{{ item.numero }}</h4>
              <div>
                <CBadge 
                  :color="getBadgeColorOrderState(item.estado)">
                  {{ orderState[item.estado] }}
                </CBadge>
              </div>
            </td>
          </template>
          <template #empresa="{item}">
              <td>
                <div>
                  <span><CIcon name="cil-building" class="mr-1"/>{{ item.empresa }}</span>
                </div>
                <div>
                  <span><i class="bi bi-postcard mr-1"></i>
                    {{ item.identificacion }}
                  </span>
                </div>
                <div>
                  <span>
                    <i class="bi bi-person-workspace mr-1"></i>
                    {{ item.empleado }}
                  </span>
                </div>
              </td>
          </template>
          <template #fechas="{item}">
            <td>
              <div>
                <i class="bi bi-calendar3 mr-1"></i>
                <span>{{ moment(item.fecha_Emision).format("DD/MM/YYYY") }}</span>
              </div>
              <div>
                <i class="bi bi-hourglass-split mr-1"></i>
                <span>{{ daysOldOrder(item) }}</span>
              </div>
            </td>
          </template>
          <template #estado="{item}">
            <td>
              <div class="d-flex justify-content-end">
                <span>${{ formatter.format(item.valor_Total) }}</span>
              </div>
            </td>
          </template>

        </CDataTable>
      </CCardBody>
    </CCard>
  </CContainer>
</template>
<script>
  import moment from "moment";
  import { formatter } from "@/general";
  import { dataGridCotizacionesPedidos } from "@/apiDataGrids";

  const fields = [
    { key: 'documento', label: 'Número', _style: 'text-align:center' },
    { key: 'empresa', label: 'Empresa', _style: 'text-align:center' },
    { key: 'fechas', label: 'Fecha', _style: 'text-align:center' },
    { key: 'estado', label: 'Estado', _style: 'text-align:center' }
  ]

  export default {
    name: "DashboardLogistics",
    setup() {

    },
    data() {
      return {
        formatter,
        loading: false,
        fields,
        items: [],
        urlHeader: "",
        saludoHorario: "",
        orderState: {
          PE: 'Pendiente',
          CP: "Convertida",
          TO: 'Facturada',
          PD: "Perdida",
          DE: "Declinada",
          CA: 'Cancelada'
        }
      }
    },
    components: {

    },
    methods: {
      moment,
      async getData() {
        this.loading = true;

        try {
          const { count, results } = await dataGridCotizacionesPedidos(this, "P", null, null);

          console.log(results);
          
          this.items = results;

          console.log(this.items);
          console.log(count);
          
          
        } catch(err) {
          console.log(err);

          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos...",
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      getUrlImg(str) {
        const images = require.context("../../../../../public/static/img", false, /\.png$/)

        return images(`./${str}`)
      },
      getBadgeColorOrderState(estado) {
        if (estado === "PE") return 'warning'
        if (estado === "CP") return "success"
        if (estado === "TO") return "success"
        // if (estado === "PE") return "danger"
        if (estado === "DE") return "danger"
        if (estado === "CA") return "danger"
      }
    },
    computed: {
      daysOldOrder() {
        return (item) => {
          return moment(item.fecha_Emision).diff(moment(), "days")
        }
      }
    },
    mounted() {
      const randomNumber = Math.floor(Math.random() * 5) + 1
      let hora = moment().format("HH")

      this.urlHeader = this.getUrlImg(`imgHeader_0${randomNumber}.png`)

      if (hora >= 0 && hora < 4) {
        this.saludoHorario = "buena noche"
      } else if (hora >= 4 && hora < 12) {
        this.saludoHorario = "buen día"
      } else if (hora >= 12 && hora < 18) {
        this.saludoHorario = "buena tarde"
      } else {
        this.saludoHorario = "buena noche"
      }

      this.getData();
    }
  }
</script>
